import { currentQueuedModalAtom } from '@/atoms/modalQueueAtoms';
import { ModalId } from '@heidi/schema/ml-scribe';
import { useAtomValue } from 'jotai';

/**
 * Hook for checking if the menu coachmark tour is active in the modal queue.
 *
 * Returns isQueueActive=true when MENU_COACHMARK_TOUR is the current modal
 * in the queue (i.e., no higher priority modals are pending).
 *
 * Used by useMenuCoachmark to coordinate with the modal queue system.
 */
export function useQueuedCoachmarkTour() {
  const currentModal = useAtomValue(currentQueuedModalAtom);

  // Tour is active when it's the current modal in queue
  const isQueueActive = currentModal?.id === ModalId.MENU_COACHMARK_TOUR;

  return { isQueueActive };
}
